const graduationDate = new Date('2026-05-19T00:00:00');

const isGraduated = new Date() >= graduationDate;

const academicSummary = isGraduated
    ? "I'm an incoming MPhil student in Electrical and Electronic Engineering at the University of Cambridge, and I graduated from the University of Rochester with a BS in Electrical and Computer Engineering. I also have a background in Computer Science from NYU Shanghai."
    : "I'm an incoming MPhil student in Electrical and Electronic Engineering at the University of Cambridge, and I'm currently completing my BS in Electrical and Computer Engineering at the University of Rochester. I also have a background in Computer Science from NYU Shanghai.";

export { academicSummary, isGraduated };
